import { memo } from 'react';
import { CART_LOC } from './ShopUtil';
import { useWatchRecord } from '../../xAppLib/Hooks';

export default memo(function ShopCartCount({ text }) {
	const cart = useWatchRecord(`${CART_LOC()}`) ?? {};
	const { qty = {}, promotions = [] } = cart;
	const count = Object.values(qty)?.filter(Boolean)?.length;
	const promotionCount = promotions?.reduce((acc, val) => acc + (val?.quantity || 1), 0);
	const totalCount = count + promotionCount;
	return (
		<div className="flex items-center">
			{text}
			{totalCount > 0 && (
				<span className={'bg-icosm-tertiary ml-1 rounded-full flex items-center justify-center text-icosm-secondary text-[12px] w-[1.5rem] h-[1.5rem] tracking-normal'}>{totalCount}</span>
			)}
		</div>
	);
});
